module.exports = __webpack_public_path__ + "static/media/Hard drive-pana.03f97825.svg";